export class FormularioLateral {
    public status: boolean;
  
  }


// WEBPACK FOOTER //
// ./src/app/models/FormularioLateral.ts